<template>
    <div>
        <div class="tab-item" >
            <div v-if="isMask" class="mask"></div>
            <div class="item-sale" v-if="tableData.length > 0">
                <div class="left">
                    <div class="div-time" >
                        <div class="time-left">活动执行日期</div>
                        <div class="time-right">
                            <span>{{ getTimename(tableData[0].timeList) }}</span>
                            <span style="color:#409EFF;margin-left: 10px;">{{ tableData[0].timeList.length }}天</span>
                        </div>
                    </div>
                </div>
                <div class="right" v-loading="loading">
                    <el-table
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        border
                        show-header
                        :span-method="objectSpanMethod">
                        <!-- :row-key="(isManypoint ? 'igniteId':'activityId')" -->
                        <!-- @selection-change="handleSelectionChange" -->
                        <!-- <el-table-column
                        type="selection"
                        :reserve-selection = true
                        align="center"
                        width="90">
                        </el-table-column> -->
                        <el-table-column
                        align="center"
                        label="BU"
                        width="70"
                        show-overflow-tooltip
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.buName">{{ scope.row.buName.split('|')[0]}}</span>
                            <span v-else></span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        prop="name"
                        label="销售大区"
                        width="100"
                        show-overflow-tooltip
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.regionName">{{ scope.row.regionName.split('|')[0] }}</span>
                            <span v-else></span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        v-if="!isEmptypoint"
                        align="center"
                        prop="address"
                        label="城市"
                        width="100"
                        show-overflow-tooltip>
                        <template slot-scope="scope">{{ getName( scope.row.areaName) }}</template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        prop="address"
                        :label="isEmptypoint? '活动地点':'街区名称'"
                        v-if="isManypoint || isEmptypoint"
                        show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.blockName }}</template>
                        </el-table-column>
                        <el-table-column
                        v-if="!isEmptypoint"
                        align="center"
                        label="售点信息"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div style="overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">
                                <span>{{ scope.row.pocName }} </span>
                                <span v-if="scope.row.pocName && scope.row.pocAddress">-</span>
                                <span v-if="scope.row.pocAddress"> {{ scope.row.pocAddress }}</span>
                            </div>
                        </template>
                        </el-table-column>
                        <el-table-column
                        v-if="!isEmptypoint"
                        align="center"
                        label="联系人信息"
                        show-overflow-tooltip
                        width="160"
                        >
                        <template slot-scope="scope">
                            <span>{{ scope.row.contactPerson }}</span>
                            <span v-if="scope.row.contactPhone && scope.row.contactPerson">-</span>
                            <span v-if="scope.row.contactPhone">{{ scope.row.contactPhone }}</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        v-if="isEmptypoint"
                        align="center"
                        label="地址"
                        show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.blockAddress }}</template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        label="百威联系人"
                        show-overflow-tooltip
                        width="160"
                        >
                        <template slot-scope="scope">{{ scope.row.bwContactPerson }}</template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        label="提报状态"
                        width="100"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div>
                                <span v-if="scope.row.activityStatus == 0">待提交</span>
                                <span v-else-if="scope.row.activityStatus == 100">Region审批</span>
                                <span v-else-if="scope.row.activityStatus == 200">BU审批</span>
                                <span v-else-if="scope.row.activityStatus == 300">HQ审批</span>
                                <span v-else-if="scope.row.activityStatus == 350">待供应商确认</span>
                                <span v-else-if="scope.row.activityStatus == 400">执行中</span>
                                <span v-else-if="scope.row.activityStatus == 500">已完成</span>
                                <span v-else-if="scope.row.activityStatus == 900">关闭/取消</span>
                                <span v-else-if="scope.row.activityStatus == 1000">
                                    <span v-if="scope.row.rejectClientLevel == 'hq'">
                                        HQ退回
                                    </span>
                                    <span v-if="scope.row.rejectClientLevel == 'bu'">
                                        BU退回
                                    </span>
                                </span>
                                <span v-else>未知</span>
                            </div>
                        </template>
                        </el-table-column>
                        <!-- <el-table-column
                        align="center"
                        label="活动时间"
                        >
                        <template slot-scope="scope">
                            <div  class="pickerOptionsNo"  style="display:flex;">
                                <div style="color:#409eff;margin:auto;" >
                                    {{ scope.row.timeList.length }}天
                                    <i class="el-icon-date" style="color:#409eff;cursor: pointer;" @click="clickDate(scope.row)"></i>
                                </div>
                                <el-date-picker
                                style="width:0px;overflow: hidden;"
                                :ref=" isEmptypoint ? 'changeFocus' + (scope.row.activityId) : 'changeFocus' + (scope.row.igniteId) "
                                popper-class="elDatePicker"
                                type="dates"
                                value-format="yyyy-MM-dd"
                                v-model="scope.row.timeListno"
                                :picker-options="pickerOptionsNo()"
                                placeholder="选择一个或多个日期"
                                size="small"
                                :clearable="false"
                                class="date-picker"
                                :default-value="defauleTime"
                                >
                                </el-date-picker>
                            </div>
                        </template>
                        </el-table-column> -->
                    </el-table>
                </div>
            </div>
            <div class="dialog-return" v-if="isShowreturn">
                <div v-if="isMask2" class="mask" style="z-index:4;"></div>
                <div class="dialog-top">
                    <div class="top-left">退回售点标记</div>
                    <div class="top-right" @click="closeReturnbtn"><i class="el-icon-close"></i></div>

                </div>
                <el-table
                    ref="returnTable"
                    :data="returnList"
                    tooltip-effect="dark"
                    style="width: 100%"
                    class="returnTable"
                    max-height="450"
                    border
                    show-header
                    :span-method="objectSpanMethod2"
                    row-key="igniteId"
                    @selection-change="handleSelectreturn"
                    >
                    <el-table-column
                    align="center"
                    label="BU"
                    width="60"
                    >
                    <template slot-scope="scope">
                        <span v-if="scope.row.buName">{{ scope.row.buName.split('|')[0]}}</span>
                        <span v-else></span>
                    </template>
                    </el-table-column>
                    <el-table-column
                    align="center"
                    prop="name"
                    label="销售大区"
                    width="90"
                    show-overflow-tooltip
                    >
                    <template slot-scope="scope">
                        <span v-if="scope.row.regionName">{{ scope.row.regionName.split('|')[0] }}</span>
                        <span v-else></span>
                    </template>
                    </el-table-column>
                    <el-table-column
                    align="center"
                    prop="address"
                    label="城市"
                    width="90"
                    show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.cityName }}</template>

                    </el-table-column>
                    <el-table-column
                    align="center"
                    prop="address"
                    label="街区名称"
                    show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.blockName }}</template>
                    </el-table-column>
                    <el-table-column
                    align="center"
                    label="售点名称"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ scope.row.pocName }}
                        <!-- <div class="store-name" @click="clickStorename(scope.row)">{{ scope.row.pocName }}</div> -->
                    </template>
                    </el-table-column>
                    <el-table-column
                    align="center"
                    label="售点地址"
                    show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.pocAddress }}</template>
                    </el-table-column>
                    <el-table-column
                    align="center"
                    label="百威联系人"
                    show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.bwContactPerson }}</template>
                    </el-table-column>
                    <!-- label-class-name="addAllChecked" -->
                    <el-table-column
                    type="selection"
                    :reserve-selection = true
                    align="center"
                    width="120">
                    </el-table-column>
                </el-table>
                <div class="btn-return">
                    <!-- <DialogPop
                    @confirm="clickReturnok()"
                    :modal= false
                    isType="0"
                    btnText="确认退回"
                    centerText="是否确认退回此活动提报？"
                    >
                    </DialogPop> -->
                    <div  class=" btn-item color-0"  @click="isMask2 = true">确认退回</div>
                    <el-dialog
                        class="myDialog"
                        :visible.sync="isMask2"
                        :modal="false"
                        title="提示"
                        width="400px"
                        center
                        top="30vh"
                        @close="clickReturnclose()"
                        >
                        <div class="main-line"></div>
                        <div class="main">
                            <div>
                                <div class="reject-top">
                                    <i style="color:rgb(230, 162, 60);font-size: 20px;margin-right: 10px;" class="el-icon-warning" ></i>
                                    <span style="font-size: 14px;">是否确认退回此活动提报？</span>
                                </div>
                                <div class="reject-area">
                                    <div class="area-left">退回理由</div>
                                    <el-input
                                        class="area-right"
                                        v-model="rejectAccountmany"
                                        type="textarea"
                                        :rows="2"
                                        placeholder="请填写退回理由"
                                        >
                                    </el-input>
                                </div>
                            </div>
                        </div>
                        <div class="main-line"></div>
                        <div style="height: 10px;"></div>
                        <span slot="footer" class="dialog-footer">
                            <el-button  size="small" @click="clickReturnclose()">取 消</el-button>
                            <el-button  size="small" type="danger" @click="clickReturnok()">确 定</el-button>
                        </span>
                    </el-dialog>
                </div>
            </div>
        </div>
        <div class="btn-all" >
            <DialogPop
            v-if="isAllbtn && tableData.length > 0 && !isManypoint"
            @confirm="sendBack"
            @opened="openDialog()"
            @getRejectaccount="getRejectaccount"
            isType="1"
            btnText="退回"
            centerText="是否退回此活动提报？"
            :isReject="true"
            :marLeft="true"
            >
            </DialogPop>
            <div  v-if="isAllbtn && tableData.length > 0 && isManypoint" @click="clickReturnbtn" class="btn-return" style="margin-right: 15px;">
                退回
            </div>
            <DialogPop
            v-if=" isAllbtn && tableData.length > 0 "
            @confirm="passThrough"
            @opened="openDialog()"
            isType="0"
            btnText="通过"
            centerText="是否通过此活动提报？"
            ></DialogPop>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import DialogPop from './dialog-pop.vue'
    import gameplanApi  from '../../../api/gameplan'
    export default {
      name: 'submit-approval-pop-form',
      props: {
        popDataitem:{type:Object, default:()=>{}},
        isAllbtn:{type:Boolean},
        queryCondition:{type:String}
      },
      components: {
        DialogPop
      },
      data () {
        return {
            tableData: [],
            themeDetail:{},
            multipleSelection: [],
            streetArr: [], // 街道数组
            streeIndex:0, // 下标
            streetArr2: [], // 街道数组
            streeIndex2:0, // 下标
            searchForm: {
                prId: '', // PR编码
                prName: '', // PR名称
                activityName: '', // 活动名称
                selectBrand: '' , // 选择品牌
                selectChannel: '', // 选择渠道
                searchStatus: '',// 查询状态
                page: 1,
                pageSize: 5,
                total:0,
                buName:'',
                regionName:''
            },
            isSinglepoint: false,
            isManypoint: false,
            isEmptypoint: false,
            isBtnsure: false,
            isShowreturn: false,
            isMask: false,
            isMask2: false,
            returnList: [],
            employeeLevel:"",
            showText:'',
            defauleTime:'',
            pickerOptionsNo(row = {}) {
                return{
                    disabledDate (time) {
                        return true
                    },
                }
            },
            loading:false,
            rejectAccountmany:'',
            rejectAccount:''
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {},
      created () {
        this.employeeLevel = this.userInfo.employeeLevel
        // console.log(this.employeeLevel,'this.employeeLevel');
        this.popData = this.popDataitem
        this.themeDetail =  this.popDataitem.themeDetail
        // console.log( this.popDataitem,' this.popDataitem');
        this.pocCountMin =  this.popDataitem.themeDetail.pocCountMin

        if (this.themeDetail.pocRelateType == '1') {
            this.isSinglepoint = true

        } else if (this.themeDetail.pocRelateType == '2') {
            this.isManypoint = true
        } else if (this.themeDetail.pocRelateType == '0') {
            this.isEmptypoint = true
        }
        // console.log(this.popData,this.isAllbtn,'提报审批页面-孙组件');
        this.init()
      },
      mounted () {},
      updated () {},
      methods: {
        init () {
            this.getActivitylist()
            this.getShowtext()
        },
        getName(str){
            if(str){
                return str.split('|')[0] || str
            }else return ''
        },
        getTimename (timeListno) {
            if (timeListno) {
                let name = ''
                name = timeListno.map((item)=>{
                    return item
                }).join(' | ')
                return name
            } else {
                return 'null'
            }
        },
        // 理由
        getRejectaccount (val) {
            this.rejectAccount = val
        },
        // 点击图标显示日期组件
        clickDate (row) {
            // console.log(row,'clickDate');
            let min = Math.min(...row.timeList.map(item => new Date(item)));
            // console.log(min,'min-submit');
            this.defauleTime = new Date(min);
            this.defauleTime.setMonth(new Date(min).getMonth());
            if (this.isEmptypoint) {
                this.$nextTick(()=>{
                    this.$refs[`changeFocus${row.activityId}`].focus()
                })
            } else {
                this.$nextTick(()=>{
                    this.$refs[`changeFocus${row.igniteId}`].focus()
                })
            }
        },
        getShowtext () {
            let needTransitions = this.themeDetail.needTransitions
            let pocRelateType = this.themeDetail.pocRelateType
            if (needTransitions == 0) {
                if (pocRelateType == '0') {
                    this.showText = '地点'
                } else if (pocRelateType == '1') {
                    this.showText = '售点'
                } else if (pocRelateType == '2') {
                    this.showText = '街区'
                }

            } else if (needTransitions == 1) {
                this.showText = '场'
            } else {
                return
            }

        },
        lockScroll() {
            let widthBar = 17, root = document.documentElement;
            if (typeof window.innerWidth == 'number') {
                widthBar = window.innerWidth - root.clientWidth;
            }
            root.style.overflow = 'hidden';
            root.style.borderRight = widthBar + 'px solid transparent';
        },

        unlockScroll() {
            let root = document.documentElement;
            root.style.overflow = '';
            root.style.borderRight = '';
        },
        openDialog () {
            // if (this.multipleSelection.length < 1) {
            //      return this.$message.error('未选择相关售点')
            // }
        },
        // 多售点退回标记
        handleSelectreturn (val) {
            // console.log(val,'多售点退回标记');
            if (val.length > 0) {
                for (let item of val) {
                    for (let item2 of this.returnList) {
                        if (item.activityPocId == item2.activityPocId) {
                            item2.rejectStatus = 1
                        }
                    }
                }
                let filterArr = this.filterArr (val,this.returnList)
                for (let item1 of filterArr) {
                    for (let item2 of this.returnList) {
                        if (item1 == item2.activityPocId) {
                            item2.rejectStatus = null
                        }
                    }
                }
            } else {
                for (let item of this.returnList) {
                    item.rejectStatus = null
                }
            }
            // console.log(this.returnList,'returnList');
        },
        filterArr(arr1, arr2) {
            let uid1=[]
            let uid2=[]
            for(let i in arr1){
                uid1.push( arr1[i].activityPocId)
            }
            for(let i in arr2){
                uid2.push( arr2[i].activityPocId)
            }
            let arr = [...uid1,...uid2];
            let newArr = arr.filter(item => {
                return !(uid1.includes(item) && uid2.includes(item));
            });
            // console.log(newArr,'newArr');
            return newArr;
        },
        // 初始化合并行数组
        mergeInit2() {
            this.streetArr2 = []; //合并街道
            this.streeIndex2 = 0; //合并街道索引
        },
    //  合并表格
        merge2(data) {
            this.mergeInit2();
            if (data.length > 0 && this.isManypoint) {
                for (let i = 0; i < data.length; i++) {
                    if (i === 0) {
                        //第一行必须存在，以第一行为基准
                        this.streetArr2.push(1); //合并医院
                        this.streeIndex2 = 0;
                    } else {
                        // 判断当前元素与上一元素是否相同
                        // 合并街区列
                        if (data[i].activityId == data[i - 1].activityId) {
                        this.streetArr2[this.streeIndex2] += 1;
                        this.streetArr2.push(0);
                        } else {
                        this.streetArr2.push(1);
                        this.streeIndex2 = i;
                        }
                    }
                }
            }
        },
        objectSpanMethod2({ row, column, rowIndex, columnIndex }) {
            if (this.isManypoint) {
                if (columnIndex === 0  ||columnIndex === 1  ||columnIndex === 2  ||columnIndex === 3  || columnIndex === 6 ) {
                    const _row_1 = this.streetArr2[rowIndex];
                    const _col_1 = _row_1 > 0 ? 1 : 0;
                    return {
                    rowspan: _row_1,
                    colspan: _col_1,
                    };
                }
            }
        },
        clickReturnbtn () {
            // console.log(this.multipleSelection,'clickReturnbtn');
            this.lockScroll()
            this.isMask = true
            this.isShowreturn = true
            let arr = []
            let multArr = []
            this.tableData.forEach((item)=> {
                return  multArr.push({'activityId':item.activityId})
            })
            // console.log(multArr,'multArr');
            for (let i = 0; i < multArr.length; i++) {
                for (let j = i+1; j < multArr.length; j++) {
                    if (multArr[i].activityId == multArr[j].activityId ) {
                        multArr.splice(j,1)
                        j--
                    }
                }
            }
            // console.log(multArr,'multArr');
            for (let item1 of multArr) {
                for (let item2 of this.tableData) {
                    if (item1.activityId == item2.activityId) {
                        arr.push(item2)
                    }
                }
            }
            this.returnList =   JSON.parse(JSON.stringify(arr))
            this.merge2(this.returnList)
        },
        closeReturnbtn () {
            this.multipleSelection = []
            this.returnList = []
            this.isMask = false
            this.isShowreturn = false
            this.unlockScroll()
            // console.log(this.returnList,'closeReturnbtn');
        },
        // 确认退回
        clickReturnok () {
            // console.log(this.returnList,'确认退回');
            let newArr= [];
            let arrId = [];
            for(let i of this.returnList){
                if(arrId.indexOf(i['activityId']) == -1){
                    arrId.push(i['activityId']);
                    newArr.push(i);
                }
            }
            // console.log(newArr);
            let arr1 = []
            for (let i = 0 ; i< newArr.length ; i++  ) {
                arr1.push(
                            {
                                gpActivityInfoDTO:{
                                    processType: '02',
                                    processAction: '03',
                                    activityId: newArr[i].activityId,
                                    submitRejectReason:this.rejectAccountmany,
                                    submitRejectPerson:this.userInfo.clientName,
                                },
                                gpActivityPocDTOList:[]
                            }
                        )
                for (let item1 of this.returnList) {
                    if (newArr[i].activityId == item1.activityId ) {
                        if (newArr[i].activityId == item1.activityId) {
                            arr1[i].gpActivityPocDTOList.push (
                                {
                                activityPocId:item1.activityPocId,
                                rejectStatus:item1.rejectStatus,
                                rejectReason:item1.rejectReason,
                                }
                            )
                        }
                    }
                }
            }
            let params1 = {
                activityInfoVOList: arr1
            }
            if (params1.activityInfoVOList.length > 0) {
                this.gamepalnActivityapprove(params1)
            }
            // console.log(params1,'params1');
            this.multipleSelection = []
            this.returnList = []
            this.isMask = false
            this.isShowreturn = false
            this.isMask2 = false
            this.rejectAccountmany = ''
            this.unlockScroll()
        },
        clickReturnclose () {
            this.isMask2 = false
            this.rejectAccountmany = ''
        },
        handleCurrentChange (val) {
            this.searchForm.page = val
            this.getActivitylist()
        },
        // 搜索
        submitForm (val) {
            this.$refs.searchForm.validate((valid) => {
            if (valid) {
                this.searchForm.page = 1
                this.getActivitylist()
            } else {
                return false;
            }
            });
        },
        // 重置
        resetForm () {
            this.$refs.searchForm.resetFields();
            this.getActivitylist()
        },
        getActivitylist () {
            this.tableData = this.popData.gpActivityInfoVOList
            this.merge(this.tableData)
        },
        getDecorates(a,b){
            let arr = a.map((item) => {
                    return item.decorateName
                }).join(b)
            return arr
        },
        // 初始化合并行数组
        mergeInit() {
        this.streetArr = []; //合并街道
        this.streeIndex = 0; //合并街道索引
        },
        //  合并表格
        merge(data) {
            this.mergeInit();
            if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                    if (i === 0) {
                        //第一行必须存在，以第一行为基准
                        this.streetArr.push(1); //合并
                        this.streeIndex = 0;
                    } else {
                        // 判断当前元素与上一元素是否相同
                        // 合并街区列
                        if (data[i].activityId == data[i - 1].activityId) {
                        this.streetArr[this.streeIndex] += 1;
                        this.streetArr.push(0);
                        } else {
                        this.streetArr.push(1);
                        this.streeIndex = i;
                        }
                    }
                }
            }
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (this.isManypoint) {
                if ( columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 6 || columnIndex === 7) {
                const _row_2 = this.streetArr[rowIndex];
                const _col_2 = _row_2 > 0 ? 1 : 0;
                return {
                rowspan: _row_2,
                colspan: _col_2,
                };
            }
            }
        },
        handleSelectionChange (val) {
        this.multipleSelection = val;
        },
        clickStorename (row) {
            this.$emit("clickStorename",row)
        },
        // 通过
        passThrough () {
            let item = this.tableData
            if (item.length == 0) {
                this.$message.error('未选择相关售点')
            } else {
                this.$emit("passThrough",item)
            }
        },
        // 退回
        sendBack () {
            let item = this.tableData
            if (item.length == 0) {
                this.$message.error('未选择相关售点')
            } else {
                let obj = {
                    item:item,
                    rejectAccount:this.rejectAccount
                }
                this.$emit("sendBack",obj)
                this.rejectAccount = ''
            }
        },
        // 点击退回
        clickReturn (row) {
            row.rejectStatus = 1
        },
        gamepalnActivityapprove (params) {
            gameplanApi.getGamepalnActivityapprove(params).then(res=>{
                if (res.data.resultCode === '0') {
                    this.$message.success('您已退回售点活动提报审批');
                    this.$router.go(-1)
                } else {
                    console.log('error');
                }
            })
        },
    }
}
</script>
<style lang="scss">
    .elDatePicker {
        .el-date-table td.selected span {
            background-color: rgb(222, 101, 45);
            color: #FFF;
            border-radius: 15px;
        }
        .el-picker-panel__footer {
            display: none;
        }
    }
</style>
<style lang="scss" scoped>
// ::v-deep .el-table__header .el-table-column--selection .cell .el-checkbox::before {
//     color: #101010;
//     content: "全选";
//     font-size: 14px;
//     margin-right: 5px;
//     font-weight: bold;
// }
.tab-item {
    // padding: 0px 10px 30px 30px;
    padding: 20px 20px;
    background-color: #FFFFFF;
    color: #101010;
    border-radius: 10px;
    font-family: SourceHanSansSC-bold;
    // height: 681px;
    font-size: 14px;
    text-align: left;
    // position: relative;
    ::v-deep.el-tabs__item.is-active {
        background-color: #FFFFFF;
        color: #409EFF;
    }

    .red {
        color: #CD1231;
        font-size: 16px;
        font-weight: bold;
        margin-top: -30px;
        height: 32px;
        line-height: 32px;
    }
    .item {
        // height: 32px;
        line-height: 32px;
        display: flex;
        .left {
            font-size: 16px;
            font-weight: bold;
            width: 20%;
        }
        .right {
            flex: 1;
        }
    }
    .item-sale {
        .left {
            // font-size: 16px;
            // font-weight: bold;
            // height: 52px;
            // line-height: 52px;
            // display: flex;
            .left-left {
                width: 20%;
                // width: 47.5%;
                line-height: 42px;
            }
            .left-right {
                // width: 90%;
                .searchForm {
                    width: 100%;
                    display: flex;
                    .item {
                        width:160px;
                        ::v-deep .el-input__inner {
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                    }
                    .item-btn {
                        margin-left: 30px;
                    }
            }
            }
            .div-time {
                font-size: 14px;
                display: flex;
                justify-content: flex-start;
                line-height: 40px;
                .time-left {
                    width: 150px;
                    font-weight: 600;
                    text-align: right;
                    margin-right: 50px;
                }
                .time-right {
                    flex: 1;
                    font-size: 14px;
                }
                }
        }
        .right {
            // width: 90%;
            // margin-left: 5%;
            ::v-deep .el-table th.el-table__cell {
                color: #101010;
                background-color: rgba(232, 232, 232);
            }
            ::v-deep .el-table__body tr.current-row>td.el-table__cell {
                background-color: #FFFFFF !important;
            }
            ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
                background-color: #FFFFFF !important;
            }
            ::v-deep .el-table .addAllChecked .cell .el-checkbox__inner{
                margin-left: 30px;
                font-size: 14px;
                font-weight: 600;
                color: #101010;
            }

            .store-name {
                color: #409EFF;
                white-space: nowrap;/*设置不换行*/
                overflow: hidden; /*设置隐藏*/
                text-overflow: ellipsis; /*设置隐藏部分为省略号*/
                cursor: pointer;
            }
            .dialog-bottom {
                position: relative;
                top: 10px;
                text-align: right;
                // ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
                // background-color: #fff;
                // color: #409EFF;
                // border: 1px solid #409EFF
                // }
                // ::v-deep .el-pagination.is-background .el-pager li:hover {
                // color: #409EFF;
                // }
                ::v-deep .el-pagination.is-background .btn-next,
                ::v-deep .el-pagination.is-background .btn-prev{
                    background-color: #FFFFFF;
                    color: #000;
                    // width: 66px;
                    border: 1px solid #C0C4CC;
                    border-radius: 3px;
                }
                ::v-deep .el-pagination.is-background .btn-next:disabled,
                ::v-deep .el-pagination.is-background .btn-prev:disabled,
                ::v-deep .el-pagination.is-background .el-pager li.disabled {
                    color: #C0C4CC;
                }
            }
        }
    }
    .mask{
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0,0,0,.7) ;
        z-index: 9999;
    }
    .dialog-return {
        position: fixed;
        top: 10vh;
        left: calc((100vw - 1000px)/2);
        width: 1000px;
        padding: 10px 20px 20px 20px;
        background-color: #FFFFFF;
        border-radius: 10px;
        z-index: 9999;
        ::v-deep .el-table__header .el-table-column--selection .cell .el-checkbox::before {
            color: #101010;
            content: "退回标记";
            font-size: 14px;
            margin-right: 5px;
            font-weight: bold;
        }
        .dialog-top {
            line-height: 20px;
            display: flex;
            margin-bottom: 10px;
            .top-left {
                font-size: 16px;
                font-weight: 600;
                flex: 1;
            }
            .top-right {
                font-size: 30px;
            }
        }
        .btn-return {
            margin-top: 10px;
            display: flex;
            justify-content: flex-end;
            margin-right: 17px;
            margin-right: 0px;
            height: 30px;
            line-height: 30px;
            .el-dialog__header {
                text-align: left;
                border-bottom: 0px;
                font-weight: normal;
            }
            .el-dialog--center .el-dialog__body {
                text-align: left;
                padding: 0px 20px 10px !important;
                font-size: 14px;
                font-weight: normal;
            }
            .el-dialog__footer {
                text-align: right !important;
                border-top: 0px;
                padding: 0px 20px 10px !important;
            .el-button {
                width: 70px;
            }
            }
            .btn-item {
                width: 84px;
                height: 32px;
                line-height: 32px;
                font-size: 14px;
                font-weight: normal;
                border-radius: 4px;
                text-align: center;
                cursor: pointer;
            }
            .color-0 {
                background-color: rgba(205, 18, 49, 1);
                color: rgba(255, 255, 255, 1);
                border: 1px solid rgba(205, 18, 49, 1);
            }
            .myDialog {
                .main {
                    padding: 5px 20px 10px ;
                    margin-bottom: 2px;
                }
                .reject-top {
                    margin: 10px 0px 10px 0px;
                }
                .reject-area {
                    display:flex ;
                    padding-bottom: 10px;
                    .area-left {
                        width: 70px;
                        margin-right:0px;
                        line-height: 31px;
                    }
                    .area-right {
                        width: 245px;
                    }
                }
                .reject-no {
                    padding: 20px 0px;
                }
                .main-line{
                    height: 1px;
                    width: 100%;
                    background-color: #BBBBBB;
                    opacity: 0.27;
                    // border: 1px solid rgba(187, 187, 187, 1);
                }
            }
        }
        ::v-deep .el-table th.el-table__cell {
            color: #101010;
            background-color: rgba(232, 232, 232);
        }
        ::v-deep .el-table__body tr.current-row>td.el-table__cell {
            background-color: #FFFFFF !important;
        }
        ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
            background-color: #FFFFFF !important;
        }
    }
}
.btn-all {
    display: flex;
    justify-content: center;
    margin-right: 17px;
    height: 32px;
    line-height: 32px;
    padding-top: 30px;
    .btn-return {
        width: 84px;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        font-weight: normal;
        border-radius: 4px;
        text-align: center;
        cursor: pointer;
        border: 1px solid rgba(205, 18, 49, 1);
        background-color: rgba(255, 255, 255, 1);
        color: rgba(205, 18, 49, 1);
    }
}
</style>
